// extracted by mini-css-extract-plugin
export default {"ModeratorInvitationListItem":"bcx_a bhy_a bhy_r bhy_j","ModeratorInvitationListItem__left":"bcx_b bhy_a bhy_j","ModeratorInvitationListItem__note":"bcx_c bhy_fo"};